import { useMemo } from "react";
import type { MergeTagV1 } from "../../../../merge-tag/types";
import { MergeTagTypeaheadOption } from "../../types/merge-tag-typeahead-option";
import { searchTags } from "../../utils/search-tags";

export const useMergeTagV1LookupService = (
  tags: MergeTagV1[],
  searchText: string | null,
): MergeTagTypeaheadOption[] => {
  return useMemo(() => {
    return searchTags(tags, searchText).map((tag) => new MergeTagTypeaheadOption(tag.id));
  }, [searchText, tags]);
};
